import { render } from "./SalesEventModal.vue?vue&type=template&id=18073c56"
import script from "./SalesEventModal.vue?vue&type=script&lang=js"
export * from "./SalesEventModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Products/GMWorkFlow/SalesEventModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18073c56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18073c56', __exports__)) {
    api.reload('18073c56', __exports__)
  }
  
  module.hot.accept("./SalesEventModal.vue?vue&type=template&id=18073c56", () => {
    api.rerender('18073c56', render)
  })

}


export default __exports__